import { LOCAL_DATA_NAME } from '@/helpers/enums';
import { getDeviceToken, isNotificationsSupported, onGetNotification } from './firebase/app';
import { getNotificationOptions } from './firebase/notification-utils';
import { preventedPagesFromNotification } from './notifications.config';

function startNotification ({ router }, callBack = () => {}) {
	return getDeviceToken().then(token => {
		let fcmToken = null;
		if (token) {
			fcmToken = token;
			localStorage.setItem(LOCAL_DATA_NAME.FCM_DEVICE_TOKEN, token);

			// initializing on get notification (foreground)
			onGetNotification((payload) => {
				const currentRouteName = router.currentRoute.name;
				if (!preventedPagesFromNotification.includes(currentRouteName)) {
					const { title, body } = payload.notification;

					const notification =
						new Notification(title, getNotificationOptions(body));

					// TODO: حدّد وجهة الانتقال حسب نوع إشعار Octopharma
					notification.onclick = () => {
						const redirectUrl = payload.data?.redirectUrl || payload.data?.url;
						if (redirectUrl) { router.push(redirectUrl).catch(() => {}); }
					};
				}
				if (typeof callBack === 'function') {
					callBack(payload);
				}
			})
		} else {
			throw new Error('No notification token generated')
		}
		return fcmToken;
	});
}

export {
	// default getting notification token function and starting notifications
	startNotification,

	// notifications basics to rebuild notification token function
	getDeviceToken,
	isNotificationsSupported,
	onGetNotification,
	getNotificationOptions
}
